'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.deck.core.filter.percent', [])
  .filter('decimalToPercent', function () {
    return function (decimal) {
      return `${Math.round(decimal * 100)}%`;
    };
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/presentation/percent.filter.js